"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UK_STRATEGIST_TEMPLATES = exports.UK_STRATEGIST_TEMPLATES_MD = void 0;
exports.UK_STRATEGIST_TEMPLATES_MD = {
    'Year Start Meeting (YSM)': `* Three Key Goals for the Year\n
* Timeline for the Year\n
* Academic Update\n
* Super-curricular Update\n
* Reading and Academic Exploration Update`,
    'Initial Strategy Meeting (ISM)': `* Introductions\n
* Overview of UK application process\n
* Answer all Initial Questions\n
* Academics Discussion\n
* Personal Development Discussion\n
* Super-Curriculars Discussion\n
* Subject Interest Development Discussion\n
* Initial Majors, Careers, Schools Discussion\n
* Next Steps and Homework Setting`,
    'Pathfinder Meeting': `* Review Pathfinder and Mark off Achieved Goals\n
* Establish 3-5 New Goals\n
* Establish Expectations around Pathfinder use during Strategy\n
* Outline Short-term (now to 3 months), Mid-term (3-6 months), and Long-term (6+ months) Goals\n
* Review Common/Expected Deadlines (eg. Oxbridge Deadlines)\n
* Review and Send the Respective NAY or AY Timelines\n
* Other Check-in Items`,
    'App Year Meeting': `* Check-in\n
* Student priorities for the session\n
* Upcoming exams/key dates\n
* Update on progress with ongoing tasks\n
* Academics\n
* Personal Development\n
* Super-Curriculars\n
* Activities\n
* Next Steps and Homework Setting`,
    'NAY: Exploration Meeting': `* Progress on Certification\n
* Lesson Plan: [insert name of Lesson Plan]\n
* Other Check-ins`,
    'NAY: Solidification Meeting': `* Progress on Certification\n
* Lesson Plan: [insert name of Lesson Plan]\n
* Other Check-ins
  `,
    'NAY: Intensification Meeting': `* Progress on Certification
* Lesson Plan: [insert name of Lesson Plan]
* Other Check-ins`,
    'NAY: Mid Review Meeting': `* First Half of the Year Reflection\n
* Candidacy Assesment\n
* Lesson Plan: [insert name of Lesson Plan]\n
* Other Check-ins`,
    'AY: Timeline Alignment': `* Upcoming Timeline Outline\n
* Personal Statement Status Update\n
* Provisional University List and Intended Degrees\n
* Candidacy Assessment\n
* Engagement Level\n
* Other Check-ins`,
    'AY: Access Meeting': '* N/A',
    'AY: Final University Selection Meeting': `* Final University List\n
* Next Application Steps\n
* UCAS Status Update`,
    'AY: UCAS Review&Submission': `* UCAS Review and Proof-Reading\n
* Personal Statement Formatting on UCAS\n
* Submission Timeline`,
    'AY: Non-UCAS App Review&Submission': `
* Application Portal Review and Proof-Reading\n
* Personal Statement Formatting\n
* Submission Timeline`,
    'AY: Pre-Interview Meeting': `* Pre-Interview Strategy Guidance and Logistical Information\n
* Interview Tutoring and Utilisation Timeline\n
* Other Preparation`,
    'AY: Post-All-UCAS Offers Meeting': `* Discussion of all 5 Outcomes\n
* Firm and Insurance Choices\n
* Other Options (Clearing, Extra) if applicable\n
* Other Crimson Opportunities`,
    'AY: Post-All-Offers Meeting': `* Discussion of all Admission Outcomes\n
    'Final Choices\n
    'Other Crimson Opportunities`,
    'AY: Final Meeting Before Contract End': `* Final Questions and Guidance Needed\n
* Other Crimson Opportunities\n
* Good Luck and Stay in Touch!`,
    Other: '* N/A',
};
exports.UK_STRATEGIST_TEMPLATES = {
    'Initial Strategy Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Overview of UK application process',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Answer all Initial Questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Academics Discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Personal Development Discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Super-Curriculars Discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Subject Interest Development Discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Initial Majors, Careers, Schools Discussion',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Next Steps and Homework Setting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Roadmap Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Review Roadmap and Ensure Student Knows How it Works',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Establish 3-5 Immediate New Goals to Add to the Roadamap',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Establish Expectations of How the Roadmap and Student Centre Will Be Used Throughout Strategy',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Outline Short-term (now to 3 months), Mid-term (3-6 months), and Long-term (6+ months) Goals',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Review Common/Expected Deadlines (eg. Oxbridge Deadlines)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Review and Send the Respective NAY or AY Timelines',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Other Check-in Items',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Year Start Meeting (YSM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Three Key Goals for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Timeline for the Year',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Academic Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Super-curricular Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Reading and Academic Exploration Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Mid Review Meeting (MRM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'First Half of the Year Reflection',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Candidacy Assesment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Lesson Plan: [insert name of Lesson Plan]',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Reengagement Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Exploration Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Progress on NAY Curriculum',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Lesson Plan: [insert name of Lesson Plan]',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Solidification Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Progress on NAY Curriculum',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Lesson Plan: [insert name of Lesson Plan]',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Intensification Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Progress on NAY Curriculum',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Lesson Plan: [insert name of Lesson Plan]',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'App Year Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Check-in',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Student priorities for the session',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Upcoming exams/key dates',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Update on progress with ongoing tasks',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Academics',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Personal Development',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Super-Curriculars',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Activities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Next Steps and Homework Setting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Timeline Alignment': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Upcoming Timeline Outline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Personal Statement Status Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Provisional University List and Intended Degrees',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Candidacy Assessment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Engagement Level',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Other Check-ins',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Access Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Final University Selection Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Final University List',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Next Application Steps',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'UCAS Status Update',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: UCAS Review&Submission': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'UCAS Review and Proof-Reading',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Personal Statement Formatting on UCAS',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Submission Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Non-UCAS App Review&Submission': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Application Portal Review and Proof-Reading',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Personal Statement Formatting',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Submission Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Pre-Interview Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Pre-Interview Strategy Guidance and Logistical Information',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Interview Tutoring and Utilisation Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Preparation',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Post-All-UCAS Offers Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of all 5 Outcomes',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Firm and Insurance Choices',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Other Options (Clearing, Extra) if applicable',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Post-All-Offers Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Discussion of all Admission Outcomes',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Other Crimson Opportunities',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Good Luck and Stay in Touch!',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=uk-strategist-v2.js.map